import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=7c5acca2&scoped=true"
import script from "./Information.vue?vue&type=script&lang=ts"
export * from "./Information.vue?vue&type=script&lang=ts"
import style0 from "./Information.vue?vue&type=style&index=0&id=7c5acca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5acca2",
  null
  
)

export default component.exports